module.exports = __webpack_public_path__ + "img/82.3.TP.8b5a790d.png";